import {Typography} from '@mui/material';
import {ICellRendererParams} from 'ag-grid-community';
import {Link, useSearchParams} from 'react-router-dom';
import {
  ENCOUNTER_DOCUMENT_ROUTE,
  ENCOUNTER_ROUTE,
} from 'src/js/containers/encounter/encounter_constants';

type OwnProps = ICellRendererParams;

type Props = OwnProps;

export const HaidiEncounterDocumentLinkFormatter: React.FC<Props> = (props) => {
  const {encounterId, documentVersionId, name} = props.value;
  const [searchParams] = useSearchParams();

  return (
    <div
      style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      <Link
        style={{textDecoration: 'underline', fontWeight: 'bolder'}}
        title={name}
        to={`${ENCOUNTER_ROUTE}/${encounterId}${ENCOUNTER_DOCUMENT_ROUTE}/${documentVersionId}?${String(
          searchParams
        )}`}
      >
        {name}
      </Link>
    </div>
  );
};
